<template>
    <div class="follow">
        <div>
            <el-button @click="onAddFollow" type="primary" plain :disabled="!editState">添加记录</el-button>
        </div>
        <br />
        <el-timeline v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.2)">
            <el-timeline-item
                :color="item.color"
                v-for="(item, index) in tableData"
                :key="`timeline${index}`"
                :timestamp="item.addTime"
                placement="top"
            >
                <el-card class="detail">
                    <div v-if="item.type === 'intention'">
                        <Tag :color="item.tagColor">{{ item.typeName }}</Tag>
                    </div>
                    <div v-else-if="item.type === 'reply'">
                        <StaffName :staff="item.staff" />
                    </div>
                    <div class="content">{{ item.content || '-' }}</div>
                </el-card>
            </el-timeline-item>
        </el-timeline>
    </div>
</template>
<script>
import { getOppoIntentRecords, getOppoIntentDeals, addIntentDeal } from '@/js/api/saleApi.js'
import { getStaffList } from '@/js/api/staffApi.js'
import dayjs from 'dayjs'

export default {
    props: ['activeItem', 'intentTypeMap', 'editState'],
    data() {
        return {
            loading: false,

            tableData: [],
        }
    },
    created() {
        this.getOppoIntentData()
    },
    methods: {
        onAddFollow() {
            this.$prompt('', '添加处理记录', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S/,
                inputErrorMessage: '请输入内容',
            })
                .then(({ value }) => {
                    addIntentDeal({ intentId: this.activeItem.id, content: value }).then(() => {
                        this.getOppoIntentData()
                        this.$emit('update')
                    })
                })
                .catch(() => {})
        },

        async getOppoIntentData() {
            this.loading = true
            const res1 = await Promise.all([
                getOppoIntentRecords({ intentId: this.activeItem.id }),
                getOppoIntentDeals({ intentId: this.activeItem.id }),
            ])
            const _list = []
            res1[0].data.forEach((item) => {
                item.addTime = item.intentTime
                if (this.intentTypeMap[item.type]) {
                    item.tagColor = this.intentTypeMap[item.type]['color']
                    item.typeName = this.intentTypeMap[item.type]['name']
                } else {
                    item.tagColor = '#aaaaaa'
                    item.typeName = '未知'
                }
                item.timeStamp = dayjs(item.intentTime).valueOf()
                item.color = '#409EFF'
                item.type = 'intention'
                _list.push(item)
            })

            const _staffIds = []
            res1[1].data.forEach((item) => {
                item.type = 'reply'
                item.addTime = item.dealTime
                item.timeStamp = dayjs(item.dealTime).valueOf()
                _list.push(item)

                if (!_staffIds.includes(item.staffId)) {
                    _staffIds.push(item.staffId)
                }
            })
            _list.sort((a, b) => a.timeStamp - b.timeStamp)

            if (_staffIds.length !== 0) {
                const res2 = await getStaffList({ staffIds: _staffIds })
                const _staffMap = {}
                res2.data.forEach((i) => {
                    _staffMap[i.id] = i
                })

                _list.forEach((item) => {
                    item.staff = _staffMap[item.staffId]
                })
            }
            this.loading = false
            this.tableData = _list
        },
    },
}
</script>
<style lang="less" scoped>
.el-timeline {
    min-height: 300px;
}
.detail {
    margin: 12px 0 0 0;
}
.content {
    padding: 6px 0;
    white-space: pre-line;
    margin-top: 12px;
    line-height: 1.5em;
}
.opt_user {
    margin-left: 12px;
    font-size: 12px;
    color: #666;
}
</style>
